import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { Config } from '../../config';
import store from '../../store';
import { accountIdSelector } from '../../store/auth/auth.selectors';

const initRdiMFEApiService = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const apiService = (await import('rdi/initApiService')).default;
    const accountIdStr = accountIdSelector(store.getState());
    const accountId = accountIdStr ? parseInt(accountIdStr, 10) : undefined;
    apiService({
      axiosInstance: RedisApiAxiosInstance,
      isRelative: Config.IS_RELATIVE_API,
      env: Config.API_ENV,
      accountId
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initRdiMFEApiService', e);
  }
};

export default initRdiMFEApiService;
